import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import { defineComponent } from 'vue';

export default defineComponent({
  name:'PDFCartaPropostaFinalizado',

  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
  },

  props: {
    cartaPropostaSelecionada: {
      type: String,
      default: ''
    },

    inputNomeCliente: {
      type: String,
      default: ''
    },
  },

  beforeMount() {
    const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    var today = new Date();
    var year = today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
    this.DiaHoje = year;
  },

  mounted() {
    if(this.cartaPropostaSelecionada) {
      this.CartaPropostaId = this.cartaPropostaSelecionada
    } else {
      this.CartaPropostaId = this.$route.params.id
    }

    this.PopulaResumaFinal()

    const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    var today = new Date();
    var year = today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
    this.DiaHoje = year;
  },

  updated() {
    if(this.cartaPropostaSelecionada === '') {
      return
    }
    if(this.cartaPropostaSelecionada) {
      this.CartaPropostaId = this.cartaPropostaSelecionada
    } else {
      this.CartaPropostaId = this.$route.params.id
    }

    this.PopulaResumaFinal()
  },

  data () {
    return {
      orcamentosInformacoes:[],
      orcamentoDatas:[],
      carregandoDados: false,
      // inputNomeCliente: '',
      infoNomeCliente: '',
      TipoCarta : 0,
      CartaPropostaId: null,
      cartaPropostaArray: {},
      icms: null,
      ipi: null,
      pisCofins: null,
      observacao: null,
      observacaoNegociacao: null,
      formaDePagamento: null,
      executarvisualizacao: 0,
      DiaHoje: null,
      dataInclusao: null,
      pdfAparecer: true,
      renderiza: false,
      inputNomeClientefinal: '',
      codigoCarta: 0,
      valoripi: 0,
      valoricms: 0,
      valorpiscofins: 0,
      arrayComponentes: [],
      formaPagto: null,
      codigoExterno: null,
      tipoFrete: null,
      arrayOrcamentosInformacoes: [],
      representante: null,
    }
  },

  methods: {
    incentivos() {
      this.incentivos

      if(this.icms === true) {
        this.icms = ("Incluso")
      } else {
        this.icms = ("Não incluso")
      }

      if(this.ipi === true) {
        this.ipi = ("Incluso")
      } else {
        this.ipi = ("Não incluso")
      }

      if(this.pisCofins === true) {
        this.pisCofins = ("Incluso")
      } else {
        this.pisCofins = ("Não incluso")
      }
    },

    juntaOrcamentosDatas() {
      this.arrayOrcamentosInformacoes = [];
      const primeiroArray = [];
      const segundoArray = [];


       this.orcamentosInformacoes.forEach((orcamento) => {
        const codigo = orcamento.codigoOrcamento;
        const frete = orcamento.indicadorDeTipoFreteoEnum;
        const nomeProduto = orcamento.nomeProduto;
        const orcamentoDatas = orcamento.orcamentoDatas;
        const novaTabela = {
          codigo,
          frete,
          nomeProduto,
          orcamentoDatas,
        }

        primeiroArray.push(novaTabela);

      });

        primeiroArray.forEach((data) => { 
          data.orcamentoDatas.forEach((data2) => {
            const preco = data2.valorPrecoIdealFormatado;
            const quantidade = data2.quantidadeFormatada;
            const novoArray = {
              codigoNovo: data.codigo,
              freteNovo: data.frete,
              nomeProdutoNovo: data.nomeProduto,
              preco, quantidade,
             }

             segundoArray.push(novoArray);
          });
        });

        this.arrayOrcamentosInformacoes = segundoArray;


        console.log(this.arrayOrcamentosInformacoes)
    },
    observacoes() {
      this.observacoes

      if(this.observacao === null) {
        this.observacao = ("Nenhuma Observação")
      } else {
        this.observacao
      }

      if(this.observacaoNegociacao === null) {
        this.observacaoNegociacao = ("Nenhuma Observação")
      } else {
        this.observacaoNegociacao
      }
    },

    async PopulaResumaFinal() {
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetResumoFinalCartaProposta/${this.CartaPropostaId}`,
      })
      .then((response) => {
        this.cartaPropostaArray = response.data.data;
        this.TipoCarta = response.data.data.tipoCarta;
        this.dataInclusao = response.data.data.dataInclusaoFormatada;
        this.orcamentosInformacoes = response.data.data.orcamentosInformacoes;
        this.icms = response.data.data.icms;
        this.ipi = response.data.data.ipi;
        this.pisCofins = response.data.data.pisCofins;
        this.observacaoNegociacao = response.data.data.observacaoNegociacao;
        this.formaDePagamento = response.data.data.formaDePagamento;
        this.codigoCarta = response.data.data.codigoCarta;
        this.nomeProduto = response.data.data.orcamentosInformacoes.nomeProduto;
        this.formaPagto = this.cartaPropostaArray.formaDePagamento 
        this.codigoExterno = this.cartaPropostaArray.codigoExterno
        this.tipoFrete = this.cartaPropostaArray.indicadorDeTipoFreteText 
        this.representante = this.cartaPropostaArray.nomeRepresentante

        this.orcamentosInformacoes.forEach((orcamentoInformacao) => {
          orcamentoInformacao.componentes.forEach((c) => {
            c.embalagens = []
            c.embalagemEspecificaFilmeEncolhivel == true ? c.embalagens.push('Filme encolhível - ' + `${c.quantidadeFilmeEncolhivel}`) : ''
            c.embalagemEspecificaCaixaColetiva == true  ? c.embalagens.push('Caixa Coletiva - ' + `${c.quantidadeCaixaColetiva}`) : ''
            c.embalagemEspecificaPalete == true  ? c.embalagens.push('Palete - ' + `${c.quantidadePalete}`) : ''
            c.embalagemEspecificaPapelEmbrulho == true  ? c.embalagens.push('Papel Embrulho - ' + `${c.quantidadePapelEmbrulho}`) : ''
            c.quantidadeOutros == null || 0  ? '' : c.embalagens.push(c.descricaoEmbalagemOutros == null || '' ? 'Outros -' : c.descricaoEmbalagemOutros + `${c.quantidadeOutros}`) 

          })
        })
        
        this.incentivos()
        this.observacoes()      
        this.GetPorcentagensImpostos()
        this.juntaOrcamentosDatas()
             

        const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

        var today = new Date();
        var year = today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
        this.DiaHoje = year;       

      })
      .catch(() => {
      });      
    },

    RotaImagem(orcamentoId){
      OrcamentoController.GetRotaImagemProduto(orcamentoId).requisicao
      .then(res => {
        const urlBase = window.location.host
        if(res.data.data === 'erro'){
          this.erro(undefined)
          return
        }
        this.caminhoImagem = `http://${urlBase}/${res.data.data}`;
        this.styleImg = 'width: 400px'

      })
    },

    erro(e){
      if(e == undefined){
        this.caminhoImagem = 'http://' + window.location.host + '/repositorio/Ilustracao_Nenhuma_Img.svg'
        this.styleImg = 'width: 100px'
      }
    },
      
    GetPorcentagensImpostos() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetPorcentagensImpostos/${this.CartaPropostaId}`,
      })
      .then((response) => {
        this.valoripi = response.data.data.porcentagemIpi
        this.valoricms = response.data.data.porcentagemIcms
        this.valorpiscofins = response.data.data.porcentagemPisCofinsFormatado   
        
        this.executaTermino() 
      })
      .catch(() => {
      });
    },

    executaTermino() {                
      this.$emit('termino')              
    },
  },

  computed:{
    deveQuebrar(){
      const arrayComponentesLength=  this.orcamentosInformacoes.map(m=>m.componentes).flat().length
      return (arrayComponentesLength <= 2 ||
        ( arrayComponentesLength %2 !== 0 && 
          arrayComponentesLength %3 !== 0 &&
          arrayComponentesLength %5 !== 0  
        )
      )
    },
  }
})